export default __webpack_public_path__ + "static/media/EM0080.34I-19684_-14854_0.89be4db6.jpg";